
<div class="flex flex-col gap-16 mt-24 md:flex-row md:gap-24">
  <poppins-card class="rounded md:w-[40%] flex flex-row gap-16">
    <div class="min-w-[120px] min-h-[120px] bg-grey-divider-subdued rounded-full" />
    <div class="w-full h-[34px] bg-grey-divider-subdued" />
  </poppins-card>
  <poppins-card class="md:w-[60%] rounded">
    <div class="w-full h-36 bg-grey-divider-subdued"></div>
    <div class="w-full h-[69px] bg-grey-divider-subdued mt-16"></div>
  </poppins-card>
</div>
